import type { FC } from 'react';
import React from 'react';
import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

interface CustomSvgIconProps extends SvgIconProps {
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'action'
    | 'disabled'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  className?: string;
  style?: React.CSSProperties;
  sx?: object;
  htmlColor?: string;
  //component: React.ElementType;
  children?: React.ReactNode;
}

const CustomSvgIcon: FC<CustomSvgIconProps> = ({
  fontSize = 'medium',
  color = 'inherit',
  className,
  style,
  sx,
  children,
  htmlColor,
  //component,
  ...props
}) => {
  return (
    <SvgIcon
      fontSize={fontSize}
      color={color}
      className={className}
      style={style}
      sx={sx}
      htmlColor={htmlColor}
      //component={component}
      {...props}
    >
      {children}
    </SvgIcon>
  );
};

export default CustomSvgIcon;
